/**
 * TimelinePreviewPage — preview af JourneyTimeline i realistisk app-kontekst.
 * URL: /timeline-preview
 */
import { useState } from 'react';
import JourneyTimeline from '../components/replay/JourneyTimeline';

const mockMedia = [
  { id: 'p1', type: 'photo',   position_progress: 0.12, url: '/assets/baremc-icon-128.png' },
  { id: 'v1', type: 'video',   position_progress: 0.38, url: '/assets/baremc-icon-128.png' },
  { id: 'p2', type: 'photo',   position_progress: 0.60, url: '/assets/baremc-icon-128.png' },
  { id: 'p3', type: 'photo',   position_progress: 0.78, url: '/assets/baremc-icon-128.png' },
];
const mockClubs = [
  { id: 'c1', name: 'BARE MC', logo_url: '/assets/baremc-icon-128.png', entry_progress: 0.50 },
];

const btnStyle = {
  padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
  background: 'rgba(255,255,255,0.10)', color: '#fff',
  border: '1px solid rgba(255,255,255,0.15)',
};

export default function TimelinePreviewPage() {
  const params    = new URLSearchParams(window.location.search);
  const initP     = params.get('p') !== null ? parseFloat(params.get('p')) : 0.38;
  const initMedia = params.get('media') === 'true';
  const fullWidth = params.get('full') === 'true';
  const soloMode  = params.get('solo') === 'true';

  const [progress,     setProgress]     = useState(initP);
  const [mediaPlaying, setMediaPlaying] = useState(initMedia);

  const totalMs   = 4 * 60 * 60 * 1000 + 46 * 60 * 1000;
  const elapsedMs = Math.round(progress * totalMs);

  // SOLO mode: JourneyTimeline i telefon-bredde (430px) med 3× zoom
  // → viser præcis hvad det ser ud som på en iPhone, men forstørret.
  if (soloMode) {
    return (
      <div style={{
        width: '100vw', height: '100vh',
        background: '#000',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        paddingBottom: 40,
      }}>
        {/* 430px bred telefon-container, 3× forstørret */}
        <div style={{
          width: 430,
          height: 240,
          position: 'relative',
          transform: 'scale(3)',
          transformOrigin: 'bottom center',
          flexShrink: 0,
        }}>
          <JourneyTimeline
            progress={progress}
            elapsedMs={elapsedMs}
            totalMs={totalMs}
            onSeek={setProgress}
            rideMedia={mockMedia}
            nearbyClubs={mockClubs}
            testId="timeline-solo"
            mediaPlaying={mediaPlaying}
          />
        </div>
      </div>
    );
  }

  // FULL-WIDTH mode: vis timeline i fuld skærmbredde (til screenshots og QA)
  if (fullWidth) {
    return (
      <div style={{
        width: '100%', height: '100vh',
        background: '#1a2a1c',
        display: 'flex', flexDirection: 'column',
        fontFamily: 'system-ui, sans-serif',
        overflow: 'hidden',
      }}>
        {/* Kortbaggrund simuleret */}
        <div style={{
          flex: 1,
          background: 'linear-gradient(175deg, #d4e8c2 0%, #b8d4a0 40%, #a0c88a 100%)',
          position: 'relative',
        }}>
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0,
            display: 'flex', justifyContent: 'center', gap: 8,
            padding: '8px 12px', zIndex: 999,
            background: 'rgba(5,13,7,0.88)', backdropFilter: 'blur(8px)',
          }}>
            <button onClick={() => setProgress(p => Math.max(0, p - 0.05))} style={btnStyle}>← -5%</button>
            <button onClick={() => setProgress(p => Math.min(1, p + 0.05))} style={btnStyle}>+5% →</button>
            <button onClick={() => setMediaPlaying(v => !v)} style={{ ...btnStyle, background: mediaPlaying ? 'rgba(45,255,136,0.30)' : 'rgba(255,80,30,0.30)' }}>
              {mediaPlaying ? 'Media OFF' : 'Media ON'}
            </button>
            <span style={{ color: 'rgba(255,255,255,0.45)', fontSize: 12, alignSelf: 'center' }}>
              {Math.round(progress * 100)}%
            </span>
          </div>
        </div>
        <div style={{ position: 'relative', height: 230, background: '#0a0f0a' }}>
          <JourneyTimeline
            progress={progress}
            elapsedMs={elapsedMs}
            totalMs={totalMs}
            onSeek={setProgress}
            rideMedia={mockMedia}
            nearbyClubs={mockClubs}
            testId="timeline-full"
            mediaPlaying={mediaPlaying}
          />
        </div>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%', minHeight: '100vh',
      background: '#050d07',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif',
    }}>

      {/* ── Kontrol-bjælke ─── */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 8,
        padding: '10px 12px', zIndex: 999,
        background: 'rgba(5,13,7,0.92)', backdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(45,255,136,0.15)',
      }}>
        <button onClick={() => setProgress(p => Math.max(0, p - 0.05))} style={btnStyle}>← -5%</button>
        <button onClick={() => setProgress(p => Math.min(1, p + 0.05))} style={btnStyle}>+5% →</button>
        <button onClick={() => setMediaPlaying(v => !v)}
          style={{ ...btnStyle,
            background: mediaPlaying ? 'rgba(45,255,136,0.30)' : 'rgba(255,80,30,0.30)',
            border: mediaPlaying ? '1px solid rgba(45,255,136,0.5)' : '1px solid rgba(255,80,30,0.5)',
          }}>
          {mediaPlaying ? 'Media OFF' : 'Media ON'}
        </button>
        <span style={{ color: 'rgba(255,255,255,0.45)', fontSize: 12, alignSelf: 'center' }}>
          {Math.round(progress * 100)}% · {Math.floor(elapsedMs/3600000)}h{Math.floor((elapsedMs%3600000)/60000)}m
        </span>
      </div>

      {/* ── Telefon-ramme ─── */}
      <div style={{
        marginTop: 64,
        width: 393, height: 852,
        borderRadius: 44,
        border: '2px solid rgba(255,255,255,0.12)',
        background: '#000',
        overflow: 'hidden',
        position: 'relative',
        boxShadow: '0 32px 80px rgba(0,0,0,0.80)',
        flexShrink: 0,
      }}>

        {/* ── Simuleret korte (ligner rigtig app) ─── */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(175deg, #d4e8c2 0%, #b8d4a0 30%, #c8dbb0 55%, #a8c890 80%, #88b870 100%)',
        }}>
          <svg width="393" height="852" style={{ position: 'absolute', inset: 0, opacity: 0.65 }}>
            <defs>
              <filter id="pg" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="3" result="b"/>
                <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
              </filter>
            </defs>
            {/* vejlinjer */}
            <path d="M60,200 Q150,350 200,420 Q260,500 310,600 Q340,660 380,720"
              stroke="#e8c030" strokeWidth="4" fill="none" strokeLinecap="round"/>
            <path d="M0,300 Q80,380 140,420 Q220,470 280,520 Q350,580 393,630"
              stroke="#e8c030" strokeWidth="4" fill="none" strokeLinecap="round"/>
            <path d="M30,100 Q100,250 180,380 Q250,470 320,580"
              stroke="#c8b070" strokeWidth="3" fill="none" strokeLinecap="round" strokeDasharray="8 6"/>
            {/* GPS-rute */}
            <path d="M20,750 Q60,700 100,660 Q160,610 220,570 Q280,530 340,490 Q370,470 393,450"
              stroke="#2DFF88" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
            {/* Motorcycle dot langs ruten */}
            <circle
              cx={20 + Math.round(progress * 373)}
              cy={750 - Math.round(progress * 300)}
              r="7" fill="#2DFF88" filter="url(#pg)"/>
          </svg>
          {/* By-labels */}
          <div style={{ position:'absolute', top:120, left:180, color:'#4a5a40', fontSize:10, fontWeight:700, letterSpacing:'0.08em' }}>GRUMLØSE</div>
          <div style={{ position:'absolute', top:260, left:70,  color:'#4a5a40', fontSize:10, fontWeight:700, letterSpacing:'0.08em' }}>LUNDBY</div>
          <div style={{ position:'absolute', top:370, left:230, color:'#4a5a40', fontSize:10, fontWeight:700, letterSpacing:'0.08em' }}>ESPELUND</div>
          <div style={{ position:'absolute', top:500, left:290, color:'#4a5a40', fontSize:10, fontWeight:700, letterSpacing:'0.08em' }}>TRELDE</div>
        </div>

        {/* ── JourneyTimeline ─── */}
        <JourneyTimeline
          progress={progress}
          elapsedMs={elapsedMs}
          totalMs={totalMs}
          onSeek={setProgress}
          rideMedia={mockMedia}
          nearbyClubs={mockClubs}
          testId="timeline-preview"
          mediaPlaying={mediaPlaying}
        />
      </div>

      <p style={{ marginTop: 16, color: 'rgba(255,255,255,0.25)', fontSize: 11, letterSpacing: '0.06em' }}>
        PREVIEW ENVIRONMENT · Klik "Save to Github" for at deploye til baremc.dk
      </p>
    </div>
  );
}
